import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "MicroscopeSharpLight",
  [
    [
      "path",
      {
        d: "M8.15857 0.299902H8.05857V0.399902V1.1499V1.7999H7.40857H6.65857H6.55857V1.8999V2.6499V14.6499V15.3999V15.4999H6.65857H7.40857H13.4086H14.1586H14.2586V15.3999V14.6499V8.00056C18.301 8.05404 21.5586 11.3448 21.5586 15.3999C21.5586 19.4884 18.2471 22.7999 14.1586 22.7999H10.4086H1.40857H0.658569H0.558569V22.8999V24.3999V24.4999H0.658569H1.40857H10.4086H14.1586H23.9086H24.6586H24.7586V24.3999V22.8999V22.7999H24.6586H23.9086H19.4572C21.7581 21.1488 23.2586 18.4504 23.2586 15.3999C23.2586 10.4093 19.2365 6.3541 14.2586 6.30044V2.6499V1.8999V1.7999H14.1586H13.4086H12.7586V1.1499V0.399902V0.299902H12.6586H11.9086H8.90857H8.15857ZM11.9086 3.4999H12.5586V13.7999H8.25857V3.4999H8.90857H9.65857H9.75857V3.3999V2.6499V1.9999H11.0586V2.6499V3.3999V3.4999H11.1586H11.9086ZM8.15857 16.7999H8.05857V16.8999V18.3999V18.4999H8.15857H8.90857H11.9086H12.6586H12.7586V18.3999V16.8999V16.7999H12.6586H11.9086H8.90857H8.15857ZM5.15857 19.7999H5.05857V19.8999V21.3999V21.4999H5.15857H5.90857H14.9086H15.6586H15.7586V21.3999V19.8999V19.7999H15.6586H14.9086H5.90857H5.15857Z",
      },
    ],
  ],
  "currentColor"
);
